import { httpGet, httpPost, httpPut, httpDelete } from '../http';

export interface BackendTeam {
  id?: number;
  name: string;
  nameEn?: string;
  title?: string;
  titleEn?: string;
  institution?: string;
  institutionEn?: string;
  photo?: string;
  bio?: string;
  bioEn?: string;
  role: 'executive' | 'advisory';
  linkedin?: string;
  created_at?: string;
  updated_at?: string;
}

export async function getAdminTeams(): Promise<BackendTeam[]> {
  return httpGet<BackendTeam[]>('/admin/teams');
}

export async function getAdminTeamById(id: number): Promise<BackendTeam> {
  return httpGet<BackendTeam>(`/admin/teams/${id}`);
}

export async function createAdminTeam(data: Partial<BackendTeam>): Promise<void> {
  return httpPost('/admin/teams', data);
}

export async function updateAdminTeam(id: number, data: Partial<BackendTeam>): Promise<void> {
  return httpPut(`/admin/teams/${id}`, data);
}

export async function deleteAdminTeam(id: number): Promise<void> {
  return httpDelete(`/admin/teams/${id}`);
}
